import React, { useState, useCallback } from "react";
import axios from "axios";
import FlashcardForm from "../components/FlashcardForm";
import FlashcardList from "../components/FlashcardList";

const Flashcard = () => {
  const token = localStorage.getItem("token");
  const [flashcards, setFlashcards] = useState([]);

  const fetchFlashcards = useCallback(async () => {
    try {
      const res = await axios.get("https://langbridge-backend.onrender.com/api/flashcards", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setFlashcards(res.data);
    } catch (error) {
      console.error("Error fetching flashcards:", error);
    }
  }, [token]);

  return (
    <div className="bg-gray">
      <FlashcardForm token={token} fetchFlashcards={fetchFlashcards} />
      <FlashcardList
        token={token}
        flashcards={flashcards}
        fetchFlashcards={fetchFlashcards}
      />
    </div>
  );
};

export default Flashcard;
